import 'svelte/internal/disclose-version';
import * as $ from 'svelte/internal/client';
import { bindPropStore } from "../bindProps";
import { text } from "../helpers";

var root = $.from_html(`<article class="slex-doc-prose"></article>`);

export default function DocProse($$anchor, $$props) {
	$.push($$props, true);

	let p = $.state($.proxy({}));

	$.user_effect(() => bindPropStore($$props.props, (next) => $.set(p, next, true)));

	var article = root();

	$.html(article, () => text($.get(p).html ?? $.get(p).content), true);
	$.reset(article);
	$.append($$anchor, article);
	$.pop();
}